import Vue from 'vue'
const data = {
    current: 0,
    clickData: false,
    connectButtonStatus: 'connect.normal',
    public: {
       normal: {
            text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/button.js_0"),
            shit: `font:14px; font-w:500;`,
            wrapper: 'w:275px; text-a:c; bgc:#00b5e2; c:#fff; box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5); active:opacity:0.6;',
            icon: { href: '', shit: `` } 
       }
    },
    connect: {
        quickNormal: {
            text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/button.js_1"),
            shit: `font:14px; font-w:500; w:230px;`,
            wrapper: 'bgc:#696969; c:#0ed3ff; box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5); active:bgc:#272727;',
            icon: { href: 'el-icon-caret-bottom', shit: `font:22px; absolute; bottom:1px; right:14px;` } 
        },
        normal: {
            text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/button.js_2"),
            shit: `font:14px; font-w:500; w:230px;`,
            wrapper: 'bgc:#696969; c:#0ed3ff; box-shadow: 0 0 3px 1px rgba(31, 31, 31, 0.5);',
            icon: { href: 'el-icon-caret-bottom', shit: `font:22px; absolute; bottom:1px; right:14px;` }
        },
        select: {
            text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/button.js_3"),
            shit: `font:14px; font-w:500; w:230px;`,
            wrapper: 'c:#0ed3ff; bgc:#272727;',
            icon: { href: 'el-icon-caret-bottom', shit: `font:22px; absolute; bottom:1px; right:14px;` }
        },
        quickSelect: {
            text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/button.js_4"),
            shit: `font:14px; font-w:500; w:230px;`,
            wrapper: 'c:#0ed3ff; bgc:#272727;',
            icon: { href: 'el-icon-caret-bottom', shit: `font:22px; absolute; bottom:1px; right:14px;` }
        },
    },
    connected: {
        normal: {
            text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/button.js_5"),
            shit: `font:12px; font-w:500; w:230px; c:#c8c8c8;`,
            wrapper: `c:#c8c8c8; bgc:#444444; border: solid 1px #696969; hover:bc:rgba(14, 211, 255, 0.6)!; hover:c:#0ed3ff!;`,
            icon: { href: 'el-icon-caret-bottom', shit: `font:20px; absolute; bottom:1px; right:12px; opacity:.5;` }
        },
        select: {
            text: Vue.prototype.$t("code-lab/component/robot-connect/device-manage/observable/button.js_6"),
            shit: `font:12px; font-w:500; w:230px; c:#c8c8c8;`,
            wrapper: `c:#c8c8c8; bgc:#272727; border: solid 1px rgba(14, 211, 255, 0.6);`,
            icon: { href: 'el-icon-caret-bottom', shit: `font:20px; absolute; bottom:1px; right:12px; c:#0ed3ff; opacity:.9;` }
        }
    },
}

export const state = Vue.observable(data)

export const mutations = {
    clickData (state, payload) {
        window.l$(state, state.button, payload)
        Object.assign(state, payload)
    },
    connectButtonStatus (state, payload) {
        window.l$(state, state.button, payload)
        Object.assign(state, payload)
    },
    current (state, payload) {
        window.l$(state, state.button, payload)
        Object.assign(state, payload)
    },
    connectedNormal (state, payload) {
        window.l$(state, payload)
        Object.assign(state.connected.normal, payload)
    },
    connectedSelect (state, payload) {
        window.l$(state, payload)
        Object.assign(state.connected.select, payload)
    }
}

export const module =  {
    namespaced: true,
    state,
    mutations
} 
